<template>
  <div class="holiday-list">
    <button
      class="btn btn-secondary mb-3 d-flex align-items-center"
      @click="$router.push('/')"
    >
      <span class="material-icons text-white me-1">arrow_back_ios</span>戻る
    </button>
    <h1 class="mb-3">出勤日設定</h1>

    <div class="content">
      <bs-alert message="平日扱いをする土日を登録してください。" color="info" />
      <bs-alert
        v-if="registeredMessage"
        :message="registeredMessage"
        color="success"
        closable
        @close="registeredMessage = ''"
      />

      <bs-alert
        v-if="errorMessage"
        :message="errorMessage"
        color="danger"
        closable
        @close="errorMessage = ''"
      />

      <div class="d-flex mb-3">
        <label for="target_year" class="col-form-label text-nowrap me-2"
          >対象年：</label
        >
        <select
          id="target_year"
          v-model="targetYear"
          class="form-select"
          style="width: 100px"
          @change="selectedYear"
        >
          <option v-for="year in yearSelection" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <div class="ms-auto d-flex">
          <button
            type="button"
            class="btn btn-primary d-flex align-items-center"
            data-bs-toggle="modal"
            data-bs-target="#modal_form"
            @click="editId = 0"
          >
            <span class="material-icons text-white me-1">add</span>
            新規登録
          </button>
        </div>
      </div>

      <div>
        <table class="table">
          <thead>
            <tr>
              <th style="width: 170px">日付</th>
              <th>名称</th>
              <th style="width: 180px">操作</th>
            </tr>
          </thead>
          <tbody v-if="workingList.length > 0">
            <tr v-for="(working, index) in workingList" :key="index">
              <td>{{ working.date_jp }}</td>
              <td>{{ working.name }}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-primary mx-3"
                  data-bs-toggle="modal"
                  data-bs-target="#modal_form"
                  @click="editId = working.id"
                >
                  編集
                </button>
                <button
                  class="btn btn-sm btn-danger mx-3"
                  @click="destroy(working.id)"
                >
                  削除
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">登録がありません。</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal_form"
      tabindex="-1"
      aria-labelledby="form_title"
      aria-hidden="true"
      ref="modal_form"
    >
      <div class="modal-dialog modal-dialog-centered">
        <working-form-view :id="editId" @registered="registered" />
      </div>
    </div>
  </div>
</template>

<script>
import client from "@/plugins/axios";
import * as constants from "@/constants";
import BsAlert from "@/components/Alert.vue";
import * as bootstrap from "bootstrap";
import WorkingFormView from "./FormView.vue";

export default {
  name: "WorkingListView",
  components: { BsAlert, WorkingFormView },
  data: () => ({
    targetYear: "",
    yearSelection: [],
    workingList: [],
    editId: -1,
    registeredMessage: "",
    errorMessage: "",
  }),
  mounted() {
    this.init();
  },
  methods: {
    init(year) {
      this.$emit("loading", true);
      client
        .get("/api/system/working", { params: { year } })
        .then((res) => {
          this.targetYear = res.data.year;
          this.yearSelection = res.data.year_selections;
          this.workingList = res.data.working;
          this.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$emit("loading", false);
        });
    },
    selectedYear() {
      this.init(this.targetYear);
    },
    registered() {
      const modal = bootstrap.Modal.getInstance(this.$refs.modal_form);
      modal.hide();
      this.registeredMessage = "出勤日設定を登録しました。";
      this.editId = -1;
      this.init(this.targetYear);
    },
    destroy(id) {
      if (
        !confirm(
          "この操作は取り消しできません。\n本当に削除してよろしいですか？"
        )
      ) {
        return;
      }

      this.$emit("loading", true);
      client
        .delete(`/api/system/working/${id}`)
        .then(() => {
          this.registeredMessage = "削除しました。";
          this.$emit("loading", false);
          this.init(this.targetYear);
        })
        .catch((error) => {
          if (error.response.status === constants.HTTP_RESPONSE_BAD_REQUEST) {
            this.errorMessage = error.response.data.detail;
          }
          this.$emit("loading", false);
        });
    },
  },
};
</script>

<style scoped>
.content {
  width: 700px;
  margin: auto;
}
</style>
